import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  title: string;
  text: string;
  busy?: boolean;
  onConfirm(): void;
  onClose(): void;
}

export default function ConfirmDialog({ open, title, text, busy, onConfirm, onClose }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("zonesPage.cancel")}</Button>
        <Button color="error" variant="contained" disabled={busy} onClick={onConfirm}>
          {t("zonesPage.delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
